const HowItWorks = () => (
  <section className="section" id="how-it-works">
    <div className="section__intro">
      <p className="eyebrow">How it works</p>
      <h2>A real game. Real learning.</h2>
      <p>
        Every quest follows the National Curriculum but feels like play. Short lessons build understanding, allowing children to progress in their skill trees and earn rewards. Story progress and badges keep children motivated whilst you get clear weekly updates.
      </p>
    </div>
    <div className="grid grid--three">
      <article className="panel">
        <h3>National Curriculum</h3>
        <p>
          Every quest maps to specific Year 1-3 objectives. Not vague "educational value" - proper alignment with the curriculum your child learns at school.
        </p>
      </article>
      <article className="panel">
        <h3>Real game, not a quiz.</h3>
        <p>
          Kids begin their adventure at their cosy home in Brightleaf Village with their new friends Moss, River and Bud! They can explore the world with learning built in to the story.
        </p>
      </article>
      <article className="panel">
        <h3>Parent designed</h3>
        <p>
          Built by a parent who couldn't find anything truly educational and fun. Screen time you can both enjoy, and a story that will spark curiosity and engagement.
        </p>
      </article>
    </div>
  </section>
);

export default HowItWorks;
